/* eslint no-console: 0 */

// catch errors
export const catchErr = (err) => {
  console.error('Error catched:', err.message, 'Please refresh.')
}

// converts object to query parameters
export const serialize = (obj) => {
  if (typeof obj !== 'object') { return obj }
  const pairs = []

  // loop throgh the objects
  Object.keys(obj).forEach((key) => {
    if (obj[key]) {
      pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
    }
  })

  return pairs.join('&')
}

export const getListIndexById = (id, list) => {
  for (let i = 0, l = list.size; i < l; i++) {
    if (list.get(i).get('id') === id) {
      return i
    }
  }

  return -1
}



// WEBPACK FOOTER //
// ./src/utils/helpers.js